import { useState } from 'react';
import { toast } from 'sonner';
import { Switch } from './ui/switch';
import { KiuAvatar } from './KiuAvatar';
import { useAuth } from '../auth/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const KiuSettings = () => {
  const { user, setUser } = useAuth();
  const [saving, setSaving] = useState(false);
  const enabled = user?.assistant_enabled !== false;
  const toggle = async (value) => {
    setSaving(true);
    try {
      const res = await fetch(`${API}/assistant/preferences`, { method: 'PUT', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ enabled: value }) });
      if (!res.ok) throw new Error();
      setUser((previous) => ({ ...previous, assistant_enabled: value }));
      toast.success(value ? 'Kiu está activado' : 'Kiu está desactivado');
    } catch { toast.error('No se pudo guardar el ajuste de Kiu'); }
    finally { setSaving(false); }
  };
  return <section id="kiu-ajustes" data-testid="profile-kiu-settings" className="sc-card p-6 md:p-8 mb-6 scroll-mt-24">
    <div className="flex items-center gap-4">
      <KiuAvatar active={enabled} className="w-12 h-12 shrink-0" />
      <div className="flex-1 min-w-0"><h2 id="kiu-settings-title" className="text-base font-semibold text-white">Kiu · tu apoyo entre bambalinas</h2><p data-testid="profile-kiu-state" className={`text-xs mt-1 ${enabled ? 'text-emerald-400' : 'text-slate-500'}`}>{saving ? 'Guardando…' : enabled ? 'Asistente IA activado' : 'Asistente IA desactivado'}</p></div>
      <Switch data-testid="profile-ai-toggle" aria-labelledby="kiu-settings-title" checked={enabled} disabled={saving} onCheckedChange={toggle} />
    </div>
    <p data-testid="profile-kiu-description" className="text-sm text-slate-400 mt-4 leading-relaxed">Kiu está disponible en todas las páginas. Pulsa su avatar o nombre para minimizarlo y vuelve a pulsarlo para abrirlo sin perder el chat. Al desactivarlo aquí desaparece por completo; se guarda automáticamente para tu cuenta.</p>
    <p data-testid="profile-kiu-privacy" className="text-xs text-slate-500 mt-2">Kiu no consulta datos privados ni comparte información de administradores. Las consultas se procesan con OpenAI; evita enviar datos personales. La conversación se conserva 7 días y puedes borrarla con «Nueva conversación».</p>
  </section>;
};
